export const languages: { value: string; label: string }[] = [
  {
    value: 'af',
    label: 'Afrikaans',
  },
  {
    value: 'ja',
    label: 'Japanese',
  },
  {
    value: 'sq',
    label: 'Albanian',
  },
  {
    value: 'kn',
    label: 'Kannada',
  },
  {
    value: 'am',
    label: 'Amharic',
  },
  {
    value: 'kk',
    label: 'Kazakh',
  },
  {
    value: 'ar',
    label: 'Arabic',
  },
  {
    value: 'km',
    label: 'Khmer',
  },
  {
    value: 'hy',
    label: 'Armenian',
  },
  {
    value: 'ko',
    label: 'Korean',
  },
  {
    value: 'az',
    label: 'Azerbaijani',
  },
  {
    value: 'ky',
    label: 'Kyrgyz',
  },
  {
    value: 'eu',
    label: 'Basque',
  },
  {
    value: 'lo',
    label: 'Lao',
  },
  {
    value: 'be',
    label: 'Belarusian',
  },
  {
    value: 'lv',
    label: 'Latvian',
  },
  {
    value: 'bn',
    label: 'Bengali',
  },
  {
    value: 'lt',
    label: 'Lithuanian',
  },
  {
    value: 'bs',
    label: 'Bosnian',
  },
  {
    value: 'mk',
    label: 'Macedonian',
  },
  {
    value: 'bg',
    label: 'Bulgarian',
  },
  {
    value: 'ms',
    label: 'Malay',
  },
  {
    value: 'my',
    label: 'Burmese',
  },
  {
    value: 'ml',
    label: 'Malayalam',
  },
  {
    value: 'ca',
    label: 'Catalan',
  },
  {
    value: 'mr',
    label: 'Marathi',
  },
  {
    value: 'zh',
    label: 'Chinese',
  },
  {
    value: 'mn',
    label: 'Mongolian',
  },
  {
    value: 'zh-CN',
    label: 'Chinese (Simplified)',
  },
  {
    value: 'ne',
    label: 'Nepali',
  },
  {
    value: 'zh-HK',
    label: 'Chinese (Hong Kong)',
  },
  {
    value: 'no',
    label: 'Norwegian',
  },
  {
    value: 'zh-TW',
    label: 'Chinese (Traditional)',
  },
  {
    value: 'pl',
    label: 'Polish',
  },
  {
    value: 'hr',
    label: 'Croatian',
  },
  {
    value: 'pt',
    label: 'Portuguese',
  },
  {
    value: 'cs',
    label: 'Czech',
  },
  {
    value: 'pt-BR',
    label: 'Portuguese (Brazil)',
  },
  {
    value: 'da',
    label: 'Danish',
  },
  {
    value: 'pt-PT',
    label: 'Portuguese (Portugal)',
  },
  {
    value: 'nl',
    label: 'Dutch',
  },
  {
    value: 'pa',
    label: 'Punjabi',
  },
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'ro',
    label: 'Romanian',
  },
  {
    value: 'en-AU',
    label: 'English (Australian)',
  },
  {
    value: 'ru',
    label: 'Russian',
  },
  {
    value: 'en-GB',
    label: 'English (Great Britain)',
  },
  {
    value: 'sr',
    label: 'Serbian',
  },
  {
    value: 'et',
    label: 'Estonian',
  },
  {
    value: 'si',
    label: 'Sinhalese',
  },
  {
    value: 'fa',
    label: 'Farsi',
  },
  {
    value: 'sk',
    label: 'Slovak',
  },
  {
    value: 'fi',
    label: 'Finnish',
  },
  {
    value: 'sl',
    label: 'Slovenian',
  },
  {
    value: 'fil',
    label: 'Filipino',
  },
  {
    value: 'es',
    label: 'Spanish',
  },
  {
    value: 'fr',
    label: 'French',
  },
  {
    value: 'es-419',
    label: 'Spanish (Latin America)',
  },
  {
    value: 'fr-CA',
    label: 'French (Canada)',
  },
  {
    value: 'sw',
    label: 'Swahili',
  },
  {
    value: 'gl',
    label: 'Galician',
  },
  {
    value: 'sv',
    label: 'Swedish',
  },
  {
    value: 'ka',
    label: 'Georgian',
  },
  {
    value: 'ta',
    label: 'Tamil',
  },
  {
    value: 'de',
    label: 'German',
  },
  {
    value: 'te',
    label: 'Telugu',
  },
  {
    value: 'el',
    label: 'Greek',
  },
  {
    value: 'th',
    label: 'Thai',
  },
  {
    value: 'gu',
    label: 'Gujarati',
  },
  {
    value: 'tr',
    label: 'Turkish',
  },
  {
    value: 'iw',
    label: 'Hebrew',
  },
  {
    value: 'uk',
    label: 'Ukrainian',
  },
  {
    value: 'hi',
    label: 'Hindi',
  },
  {
    value: 'ur',
    label: 'Urdu',
  },
  {
    value: 'hu',
    label: 'Hungarian',
  },
  {
    value: 'uz',
    label: 'Uzbek',
  },
  {
    value: 'is',
    label: 'Icelandic',
  },
  {
    value: 'vi',
    label: 'Vietnamese',
  },
  {
    value: 'id',
    label: 'Indonesian',
  },
  {
    value: 'zu',
    label: 'Zulu',
  },
  {
    value: 'it',
    label: 'Italian',
  },
];
